export const VIEW_TILE = 'tile';
export const VIEW_HORIZONTAL = 'horizontal';
